import { createContext, useContext } from 'react'
import { Config } from '../types'

export const PageContext = createContext<Config | null>(null)

export const usePageContext = () => {
    return useContext(PageContext)
}
